import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@mui/material';

// ============================================
// Layout
// ============================================
export const TabsWrapper = styled(Box)({
  marginTop: '12.5px',
  paddingBottom: 0,
  height: '40px',
});

export const Card = styled(Paper)({
  background: '#fff',
  borderRadius: '10px',
  padding: '30px 40px',
});

export const SearchRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const SearchGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const SearchLabel = styled(Typography)({
  marginRight: '20px',
  fontSize: '12px',
  fontWeight: 500,
  minWidth: '50px',
});

export const SearchButtonWrapper = styled(Box)({
  marginLeft: '4px',
});

// ============================================
// Tabs
// ============================================
export const StyledTabs = styled(Tabs)({
  '& .MuiTab-root.MuiTab-textColorSecondary': {
    borderRadius: '12px',
    border: '1px solid #0F7F85',
    marginRight: '10px',
    minWidth: '100px',
    minHeight: '40px !important',
    padding: '12px 40px',
    fontWeight: 500,
    fontSize: '13px',
  },
  '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
    background: '#0F7F85',
    borderRadius: '12px',
    border: 'none',
    color: '#fff',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

// ============================================
// Table
// ============================================
export const StyledTableContainer = styled(Box)({
  border: '1px solid #ddd',
  overflow: 'auto',
});

export const StyledTable = styled(Table)({
  minWidth: 550,
});

export const StyledTableHead = styled(TableHead)({
  background: '#fafbfc',
});

export const HeaderCell = styled(TableCell)({
  fontSize: '12px',
  fontWeight: 500,
  borderRight: '1px solid #ddd',
  '&:last-child': {
    borderRight: 'none',
  },
});

export const BodyRow = styled(TableRow)({
  cursor: 'pointer',
  textDecoration: 'none',
  '&:last-child td, &:last-child th': { borderBottom: 0 },
  '&:hover': { background: '#f0f0f0' },
});

export const BodyCell = styled(TableCell)({
  borderRight: '1px solid #ddd',
  '&:last-child': {
    borderRight: 'none',
  },
});

export const NameCellInner = styled(Box)({
  display: 'flex',
  gap: '10px',
  justifyContent: 'center',
});

export const PendingDot = styled(Box)({
  width: '8px',
  height: '8px',
  background: '#ff0000',
  borderRadius: '50%',
});

export const NameText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isPending',
})(({ isPending }) => ({
  fontWeight: isPending ? 800 : 400,
}));

// ============================================
// Approve Button (행 단위)
// ============================================
export const ApproveButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isPending',
})(({ isPending }) => ({
  padding: '12px 25px',
  borderRadius: '5px',
  height: '36px',
  background: isPending ? '#0F7F85' : '#98A6AD',
  color: '#fff',
  '&:hover': {
    background: isPending ? '#0F7F85' : '#ddd',
    color: '#fff',
  },
}));

// ============================================
// Cancel(Rollback) Button (행 단위) — 승인된 양도 당일 롤백
// ============================================
export const CancelButton = styled(Button)({
  padding: '12px 25px',
  borderRadius: '5px',
  height: '36px',
  background: '#D9534F',
  color: '#fff',
  '&:hover': {
    background: '#C9302C',
    color: '#fff',
  },
  '&.Mui-disabled': {
    background: '#e0e0e0',
    color: '#fff',
  },
});
